import axios from "axios";
import API_URL from "../utils/api-url";
import DataStructureModifierHelper from "./DataStructureModifierHelper";

class ActionHelper {
  static requestServer(
    method,
    url,
    payload = null,
    requestActionType = null,
    successActionType = null,
    failActionType = null,
    dispatch = () => {},
    requestCallback = () => {},
    successCallback = () => {},
    failCallback = () => {},
  ) {
    return new Promise((resolve, reject) => {
      if (requestActionType && dispatch) dispatch({ type: requestActionType });
      requestCallback();

      let promise;

      const apiUrl = API_URL + url;

      switch (method) {
        case "GET":
          promise = axios.get(apiUrl, payload);
          break;

        case "POST":
          promise = axios.post(apiUrl, payload);
          break;

        case "PUT":
          promise = axios.put(apiUrl, payload);
          break;

        case "PATCH":
          promise = axios.patch(apiUrl, payload);
          break;

        case "DELETE":
          promise = axios.delete(apiUrl, payload);
          break;

        default:
          promise = axios.get(apiUrl, payload);
          break;
      }

      promise
        .then((response) => {
          if (successActionType && dispatch) {
            dispatch({ type: successActionType, payload: response.data });
          }
          resolve(response.data);
          successCallback(response);
        })
        .catch((err) => {
          if (failActionType && dispatch) {
            dispatch({
              type: failActionType,
              payload: DataStructureModifierHelper.errorMessagesToStringArray(
                err.response ? err.response.data : err.message,
              ),
            });
          }
          reject(
            DataStructureModifierHelper.errorMessagesToStringArray(
              err.response ? err.response.data : err.message,
            ),
          );
          failCallback(err);
        });
    });
  }
}

export default ActionHelper;



// WEBPACK FOOTER //
// ./src/helpers/ActionHelper.js